/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ShuffleIcon = ({ width = 24, height = 24, hidden = false, title = 'Shuffle' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M18.74414,4.1875l-2.25-2.25c-.29297-.29297-.76758-.29297-1.06055,0s-.29297.76758,0,1.06055l1.00195,1.00195h-2.22363c-2.1084,0-4.00098,1.29883-4.79688,3.25195l-2.46973,4.87305c-.58887,1.44238-1.93652,2.375-3.43359,2.375h-1.79785c-.41406,0-.75.33594-.75.75s.33594.75.75.75h1.79785c2.10938,0,4.00293-1.29883,4.79688-3.25195l2.46973-4.87305c.58984-1.44238,1.9375-2.375,3.43359-2.375h2.15918l-.9375.9375c-.29297.29297-.29297.76758,0,1.06055.14648.14648.33789.21973.53027.21973s.38379-.07324.53027-.21973l2.25-2.25c.29297-.29297.29297-.76758,0-1.06055Z"
      fill="currentColor"
      stroke-width="0"
    />
    <path
      d="M7.10254,7.38867c-.23438,0-.46484-.10938-.61133-.31348-.7041-.98633-1.81836-1.5752-2.97949-1.5752h-1.79785c-.41406,0-.75-.33594-.75-.75s.33594-.75.75-.75h1.79785c1.64453,0,3.21484.82324,4.2002,2.20215.24023.33789.16309.80566-.17383,1.04688-.13281.09473-.28516.13965-.43555.13965Z"
      fill="currentColor"
      stroke-width="0"
    />
    <path
      d="M18.74414,14.73633l-2.25-2.25c-.29297-.29297-.76758-.29297-1.06055,0s-.29297.76758,0,1.06055l.95312.95312h-2.17383c-1.15527,0-2.26562-.58398-2.9707-1.5625-.24121-.33398-.70898-.41211-1.04688-.16992-.33594.24219-.41211.71094-.16992,1.04688.98535,1.36816,2.55078,2.18555,4.1875,2.18555h2.20703l-.98633.98633c-.29297.29297-.29297.76758,0,1.06055.14648.14648.33789.21973.53027.21973s.38379-.07324.53027-.21973l2.25-2.25c.29297-.29297.29297-.76758,0-1.06055Z"
      fill="currentColor"
      stroke-width="0"
    />
  </svg>`;
};
